// extracted by mini-css-extract-plugin
export default {"container":"CJR+p","button":"++KUH"};